import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticated } from '@/utils/query-utils'

export const useGeneratorsPortfolioStatusSummaryQuery = () => {
    return useQuery({
        queryKey: ['generators', 'portfolioOverview', 'statusSummary'],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.portfolioOverviewApi.getGeneratorPortfolioSummary(
                {},
                {
                    signal,
                },
            )
            return result
        },
        enabled: whenAuthenticated,
    })
}
